import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    ElementRef,
    ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RecordAction } from "../../../../../../../../../utils/enums/shared/enums";
import { Contact } from "../../../../../../../../../utils/types/admon/contact.type";
import { ContactService } from "../../../../../../../../../services/admon/contact.service";
import { ShortCodeService } from "../../../../../../../../../services/operator/shortcode.service";
import { ShortCodeDatasource } from "../../../../../../../../../utils/datasources/operator/shortcode.datasource";
import { ShortCodeCompany } from "../../../../../../../../../utils/types/admon/shortCodesCompany.type";
import { OperatorCompany } from "../../../../../../../../../utils/types/admon/OperatorCompany.type";
import { CompanyOperatorDatasource } from "../../../../../../../../../utils/datasources/admon/operator.datasource";
import { CompanyOperatorService } from "../../../../../../../../../services/admon/operator.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-contact-form",
    templateUrl: "./operator-form.component.html",
    styleUrls: ["./operator-form.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [
        ContactService,
        ShortCodeDatasource,
        ShortCodeService,
        CompanyOperatorDatasource,
        CompanyOperatorService,
    ],
})
export class OperatorCompanyFormComponent implements OnInit {
    operator: OperatorCompany = new OperatorCompany();
    dialogTitle: string;
    shortCodeForm: FormGroup;
    action: RecordAction;
    callback: (shortCodesToInsert) => void;
    operators: any = [];
    shortCodes: any = [];
    shortCodesToInsert: any = [];

    recordAction = RecordAction;
    form: FormGroup;
    companyId: any;

    @ViewChild("inputFile") myInputVariable: ElementRef;
    datasource: CompanyOperatorDatasource;

    constructor(
        public dialogRef: MatDialogRef<OperatorCompanyFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private contactService: ContactService,
        private shortCodeService: ShortCodeService,
        private shortCodeDataSource: ShortCodeDatasource,
        private _datasource: CompanyOperatorDatasource,
        private service: CompanyOperatorService,
        private translateService: TranslateService
    ) {
        this.datasource = _datasource;
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.action = data.action;
        this.callback = data.callback;
        this.operators = data.operators;
        this.companyId = data.companyId;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.operator = data.operator;

            this.dialogTitle = data.title;

            this.shortCodeDataSource
                .getListInside(this.operator.operator_id)
                .subscribe((res) => {
                    this.shortCodes = res.rows;

                    this.service
                        .getShortCodesList(
                            this.companyId,
                            this.operator.operator_id
                        )
                        .subscribe((result) => {
                            this.operator.ShortCodes = [];
                            for (const item of result.rows) {
                                const shortCode = new ShortCodeCompany();
                                shortCode.organization_id = this.companyId;
                                shortCode.short_code_id = item.id;
                                shortCode.description = "";
                                shortCode.esm_class = 0;
                                shortCode.register_delivery = 0;
                                shortCode.service_type = 0;
                                shortCode.operator_id =
                                    this.operator.operator_id;
                                this.operator.ShortCodes.push(shortCode);
                            }
                        });
                });

            // this.operator.ShortCodes = [];
            // this.operator.ShortCodes = this.shortCodes;
        } else {
            this.dialogTitle = "Nueva Operadora";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
        }
        this.shortCodeForm = this.createForm();
    }

    ngOnInit() {}

    onChangeShortCode(event) {
        this.shortCodesToInsert = [];
        const items = event.value;
        for (const item of items) {
            if (item !== "") {
                this.shortCodesToInsert.push({ id: item.id });
            }
        }
    }

    changeOperator(event) {
        if (event.value) {
            this.shortCodeDataSource
                .getListInside(event.value)
                .subscribe((res) => {
                    this.shortCodes = res.rows;
                });
        } else {
            this.shortCodes = [];
        }
    }

    createForm() {
        this.form = new FormGroup({
            operator_id: new FormControl(this.operator.operator_id, [
                Validators.required,
            ]),
            shortCodesControl: new FormControl(this.operator.ShortCodes, [
                Validators.required,
            ]),
        });

        const form = this.form;
        form.controls["operator_id"].valueChanges.subscribe(
            (value) => (this.operator.operator_id = value)
        );
        form.controls["shortCodesControl"].valueChanges.subscribe(
            (value) => (this.operator.ShortCodes = value)
        );

        return form;
    }
    save() {
        if (this.shortCodeForm.invalid) {
            return;
        }

        this.operator.ShortCodes = [];

        this.operator.organization_id = this.companyId;

        for (const item of this.shortCodesToInsert) {
            const shortCode = new ShortCodeCompany();
            shortCode.organization_id = this.companyId;
            shortCode.short_code_id = item.id;
            shortCode.description = "";
            shortCode.esm_class = 0;
            shortCode.register_delivery = 0;
            shortCode.service_type = 0;
            shortCode.operator_id = this.operator.operator_id;
            this.operator.ShortCodes.push(shortCode);
        }

        this.callback(this.operator);
    }

    compareFn(op1: any, op2: any) {
        return op1.id === op2.short_code_id;
    }
}
